import * as types from "@/store/customer/types";

export default {
  [types.SET_CUSTOMERLIST](state, payload) {
    state.customerList = payload;
  }
};
